var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader",class:{'is-active': _vm.isActive, 'is-grey': _vm.grey},style:({height: _vm.loaderHeight + 'px'})},[_c('span',{staticClass:"loader__spinner"})])}
var staticRenderFns = []

export { render, staticRenderFns }